<template>
  <div v-if="show" class="modal-root" @click.self="close">
    <div class="modal-content">
      <button
        @click="downloadImage"
        class="modal-download-button"
        title="다운로드"
      >
        <img src="@/assets/icons/download.png" alt="다운로드" style="width:20px;height:20px;" />
      </button>
      <button
        @click="close"
        class="modal-close-button"
        title="닫기"
      >
        <span class="material-icons">close</span>
      </button>
      <img
        :src="imageUrl"
        :alt="imageAlt"
        class="modal-image"
        @click.stop
      />
      <div v-if="!imageUrl" class="file-desc">이미지 미리보기를 불러올 수 없습니다.</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    imageUrl: {
      type: String,
      required: true
    },
    imageAlt: {
      type: String,
      default: '이미지'
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    downloadImage() {
      const a = document.createElement('a')
      a.href = this.imageUrl
      a.download = this.imageAlt || 'image.png'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    }
  },
  watch: {
    show(newVal) {
      if (newVal) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    }
  },
  mounted() {
    const handleEsc = (e) => {
      if (e.key === 'Escape' && this.show) {
        this.close()
      }
    }
    document.addEventListener('keydown', handleEsc)
    this.$once('hook:beforeDestroy', () => {
      document.removeEventListener('keydown', handleEsc)
    })
  },
  beforeDestroy() {
    document.body.style.overflow = ''
  }
}
</script>

<style scoped>
.modal-root {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100000;
}

.modal-content {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
}

.modal-download-button {
  position: absolute;
  top: -40px;
  right: 40px;
  padding: 8px;
  background: none;
  border: none;
  cursor: pointer;
}

.modal-close-button {
  position: absolute;
  top: -40px;
  right: 0;
  padding: 8px;
  color: white;
  cursor: pointer;
}

.modal-close-button:hover {
  opacity: 0.8;
}

.modal-image {
  max-width: 100%;
  max-height: 90vh;
  object-fit: contain;
  border-radius: 8px;
}

.material-icons {
  font-family: 'Material Icons';
  font-weight: normal;
  font-style: normal;
  font-size: 24px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  -webkit-font-smoothing: antialiased;
}

.file-desc {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 8px;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  border-radius: 0 0 8px 8px;
  text-align: center;
}
</style> 